import { Suspense } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout from "./components/layout/Layout";
import Home from "./pages/Home";
import HousePitahaya from "./pages/HousePitahaya";
import AboutUs from "./pages/AboutUs";
import HouseMolenillo from "./pages/HouseMolenillo";
import Error from "./pages/Error";
import Checkout from "./pages/Checkout";
import Spinner from "./components/Spinner";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    errorElement: <Error />,
    children: [
      {
        path: "/",
        element: <Home />
      }, {
        path: "/molenillo",
        element: <HouseMolenillo />
      }, {
        path: "/pitahaya",
        element: <HousePitahaya />
      }, {
        path: "/about-us",
        element: <AboutUs />
      }, {
        path: "/checkout",
        element: <Checkout />
      },
    ]
  }
]);

const App = () => {

  return (
    <RouterProvider router={router} />
  );
}

const Loading = () => {
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
      <Spinner />
    </div>
  )
}

export default function WrappedApp() {
  return (
    <Suspense fallback={<Loading />}>
      <App />
    </Suspense>
  );
}
